import {
  makeStyles,
  SelectTabData,
  SelectTabEvent,
  Tab,
  TabList,
  TabValue,
} from "@fluentui/react-components";
import React, { useContext, useEffect } from "react";
import { LayoutContext } from "../../../../../context/LayoutContext";
import { $sky90 } from "../../../../../cssjs/colors";
import { FlightLegTypeEnum } from "../../../../../enum/FlightsEnum";
import FlightListTabContent from "./tab-content/FlightListTabContent";

export const FlightTabs: React.FunctionComponent<any> = ({
  showFlightDetails = false,
}): React.JSX.Element => {
  const classes = useStyles();
  const { setFlightFilterParams } = useContext(LayoutContext);

  const [tabLoading, setTabLoading] = React.useState<boolean>(false);
  const [selectedValue, setSelectedValue] = React.useState<TabValue>(
    FlightLegTypeEnum.All
  );

  const onTabSelect = async (_event: SelectTabEvent, data: SelectTabData) => {
    setSelectedValue(data?.value);

    const legType: string | null =
      data?.value === FlightLegTypeEnum.All ? null : (data?.value as string);
    setFlightFilterParams((oldParams) => {
      const updatedParams = { ...oldParams };
      updatedParams.legType = legType;
      return updatedParams;
    });
  };

  useEffect(() => {
    setFlightFilterParams((oldParams) => {
      const updatedParams = { ...oldParams };
      updatedParams.legType = null;
      return updatedParams;
    });
  }, []);

  return (
    <div
      className={showFlightDetails ? classes.rootHidden : classes.root}
      data-testid="flight-tabs"
    >
      <div className="fs-20 mb-2">Flights</div>
      <TabList
        className={classes.tabListContainer}
        selectedValue={selectedValue}
        onTabSelect={onTabSelect}
      >
        <Tab id="All" value={FlightLegTypeEnum.All} disabled={tabLoading}>
          All
        </Tab>
        <Tab
          id="Arrivals"
          value={FlightLegTypeEnum.Arrival}
          disabled={tabLoading}
        >
          Arrivals
        </Tab>
        <Tab
          id="Departures"
          value={FlightLegTypeEnum.Departure}
          disabled={tabLoading}
        >
          Departures
        </Tab>
      </TabList>
      <div className={classes.panels}>
        <FlightListTabContent
          type={selectedValue as FlightLegTypeEnum}
          setTabLoading={setTabLoading}
        />
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  rootHidden: {
    visibility: "hidden",
  },
  root: {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    padding: "24px 16px 16px 16px",
    color: "#000000",
  },
  tabListContainer: {
    width: "100%",
    justifyContent: "space-around",
    "& .fui-Tab": {
      paddingLeft: "0px",
      paddingRight: "0px",
      width: "33%",
      ":after": {
        paddingLeft: "0px",
        paddingRight: "0px",
        backgroundColor: $sky90,
        left: "0px",
        right: "0px",
      },
      ":enabled:hover::after": {
        backgroundColor: $sky90,
      },
    },
  },
  panels: {
    position: "relative",
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: "300px",
    maxHeight: "calc(66vh - 260px)",
    overflowY: "auto",
  },
});
